export const extractPaths = (dataMenu, isAll) => {
  const accessList = [];
  dataMenu?.map((x) => {
    const access = [{ name: x?.name, path: x?.link, action: ['read'] }];
    x?.submenu?.map((y) => {
      const confidential = [
      ];
      if (confidential.includes(y?.link) && !isAll) access.push({ name: y?.name, path: y?.link, action: [] });
      else access.push({ name: y?.name, path: y?.link, action: ['read'] });
    });
    accessList.push(access);
  });

  return accessList;
};
